module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-09-741b6659b22c03f94b217028d8d8a59f.jpg";